module.exports = __webpack_public_path__ + "img/0x59193512877E2EC3bB27C178A8888Cfac62FB32D.a5fe2e33.png";